import { render } from "./CohortsList.vue?vue&type=template&id=5c578791"
import script from "./CohortsList.vue?vue&type=script&lang=js"
export * from "./CohortsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__